import { render } from "./NextButton.vue?vue&type=template&id=8b1a1712&ts=true"
import script from "./NextButton.vue?vue&type=script&lang=ts"
export * from "./NextButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__